import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DetailWindowSkeleton = () => {
  return (
    <div className="container">
      <div className="inner-content">
        <div className="row bread-and-sort">
          <div className="col-lg-8 col-md-8 col-sm-12">
            {/* Carousel Skeleton */}
            <div className="carousel slide">
              <div className="carousel-inner carousel-inner-height align-content-center">
                <div className="carousel-item active">
                  <Skeleton height={400} width="100%" />
                </div>
              </div>
            </div>
            {/* Heading and Description */}
            <Skeleton height={30} width="60%" className="mb-3" />
            <Skeleton height={20} width="100%" count={3} className="mb-2" />
            {/* Details Row */}
            <div className="row">
              <div className="col-6">
                <Skeleton height={20} width="80%" />
              </div>
              <div className="col-6">
                <Skeleton height={20} width="80%" />
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            {/* Logo */}
            <Skeleton height={100} width={100} className="detail-logo mb-3" />
            {/* Title */}
            <Skeleton height={30} width="80%" className="mb-2" />
            {/* Location */}
            <Skeleton height={20} width="70%" className="mb-2" />
            {/* Badges */}
            <Skeleton height={25} width="50%" className="mb-2" />
            {/* Views */}
            <Skeleton height={20} width="40%" className="mb-2" />
            {/* Date */}
            <Skeleton height={20} width="60%" className="mb-3" />
            <hr className="detail-custom-border" />
            {/* Contact Button */}
            <Skeleton height={40} width="100%" className="mb-3" />
            <hr className="detail-custom-border" />
            {/* Social Links */}
            <div className="d-flex mb-3">
              <Skeleton height={30} width={30} className="me-2" />
              <Skeleton height={30} width={30} className="me-2" />
              <Skeleton height={30} width={30} />
            </div>
            {/* Copy Button */}
            <Skeleton height={40} width="100%" className="mb-3" />
            {/* Stay Safe Card */}
            <div className="card detail-card">
              <div className="card-body">
                <Skeleton height={25} width="50%" className="mb-2" />
                <Skeleton height={20} width="100%" count={2} className="mb-2" />
                <Skeleton height={35} width="80%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailWindowSkeleton;
